// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605282333/js/" + chunkId + "." + {"44":"e44df967","225":"19bb2501","481":"20227974","486":"f9adb210","770":"947e5c6b"}[chunkId] + ".0.9267516654363667.chunk.js";
};